class SpecialOprations extends HTMLElement {
    constructor() { super() }

    connectedCallback() {}

    attributeChangedCallback(attName, oldValue, newValue) {
        switch (attName) {
        case 'css': {
            const styleSheet = document.createElement('style')
            styleSheet.innerText = newValue
            document.head.appendChild(styleSheet)
            break
        }
        case 'headerconfig': {
            const headerConfig = JSON.parse(newValue)
            window.WIX_HEADER_CONFIG = headerConfig
            break
        }
        }
    }

    static get observedAttributes() { return ['css', 'headerconfig'] }
}

customElements.define('special-oprations', SpecialOprations)